import { createSelector } from 'reselect';
import { selectEventsBySportId } from '../../store';

export const selectHasEvents = (sportId) =>
  createSelector(selectEventsBySportId(sportId), (events) => events.length > 0);
